import { Button } from "@/components/ui/button";

interface FormActionsProps {
  onClose: () => void;
  isSubmitting: boolean;
  isEditing: boolean;
}

const FormActions = ({ onClose, isSubmitting, isEditing }: FormActionsProps) => {
  return (
    <div className="flex justify-end gap-4">
      <Button type="button" variant="outline" onClick={onClose}>
        Cancel
      </Button>
      <Button 
        type="submit" 
        disabled={isSubmitting}
        variant="secondary"
        className="bg-secondary text-white hover:bg-secondary/80"
      >
        {isSubmitting ? "Saving..." : isEditing ? "Update Event" : "Create Event"}
      </Button>
    </div>
  );
};

export default FormActions;